<div class="loader-container">
    <app-rat-loader [ngClass]="isLoading? 'visible':'invisible'"></app-rat-loader>
    <!-- <app-rat-loader></app-rat-loader> -->
</div>
<ng-container>
    <router-outlet></router-outlet>
</ng-container>